module.exports = __webpack_public_path__ + "img/PersonLock.9d7d4568.svg";